import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Footer() {
  const { ref: footerRef, isVisible: footerVisible } = useScrollAnimation<HTMLElement>({ threshold: 0.1 });

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8" ref={footerRef}>
      <div className="w-full px-6">
        <div className="max-w-[90%] mx-auto">
          <div className={`grid md:grid-cols-4 gap-12 mb-12 transition-all duration-1000 ${footerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div>
              <img 
                src="https://static.readdy.ai/image/d1ac1a7e8ecb2076670ea669c1984b4f/c003d2c129b52bdbbe2de4fac95e67e5.png" 
                alt="Persona Pro Logo" 
                className="h-12 w-auto mb-4"
              />
              <p className="text-gray-400 leading-relaxed text-sm">
                Ao optar por terceirizar seus serviços com a Persona Pro, você estará confiando suas atividades a uma empresa especializada em adquirir, reter, gerir, treinar e desenvolver mão de obra qualificada.
              </p>
              <div className="flex space-x-4 mt-6">
                <a href="https://www.facebook.com/Personaprorh" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-[#D4AF37] rounded-full flex items-center justify-center hover:bg-[#B8941F] transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4 text-[#D4AF37]">Navegação</h3>
              <ul className="space-y-3">
                <li>
                  <button onClick={() => scrollToSection('inicial')} className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Inicial
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('quem-somos')} className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Quem Somos
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('servicos')} className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Serviços
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('comentarios')} className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Comentários
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('contato')} className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Contato
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4 text-[#D4AF37]">Serviços</h3>
              <ul className="space-y-3">
                <li className="text-gray-400">Recrutamento e Seleção</li>
                <li className="text-gray-400">Consultoria em RH</li>
                <li className="text-gray-400">Treinamento e Desenvolvimento</li>
                <li className="text-gray-400">Headhunting Executivo</li>
                <li className="text-gray-400">Avaliação de Desempenho</li>
                <li className="text-gray-400">Terceirização de RH</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4 text-[#D4AF37]">Contato</h3>
              <ul className="space-y-3">
                <li className="flex items-start text-gray-400">
                  <i className="ri-phone-line text-[#D4AF37] mr-2 mt-1"></i>
                  <div>(41) 3344-2203</div>
                </li>
                <li className="flex items-start text-gray-400">
                  <i className="ri-map-pin-line text-[#D4AF37] mr-2 mt-1"></i>
                  <div>
                    Rua Coronel Herculano de Araujo, nº 417<br />
                    Novo Mundo<br />
                    Curitiba - PR<br />
                    CEP: 81050-090
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className={`border-t border-gray-700 pt-8 transition-all duration-1000 delay-300 ${footerVisible ? 'opacity-100' : 'opacity-0'}`}>
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm mb-4 md:mb-0">
                © 2025 Persona Pro. Todos os direitos reservados.
              </p>
              <div className="flex items-center space-x-4">
                <a href="https://bgtricem.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Bgtricem
                </a>
                <span className="text-gray-600">|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
